import { API_ENDPOINTS } from "config/config";
import { buildAnalyticsQueryParams } from "utils/analyticsQueryParams";

const get = async (api, endpoint, params = {}) => {
  const response = await api.get(endpoint, {
    params: buildAnalyticsQueryParams(params),
  });
  return response.data.data;
};

export const getMarketingOverview = (api, params) =>
  get(api, API_ENDPOINTS.MARKETING_OVERVIEW, params);

export const getUtmBreakdown = (api, params) =>
  get(api, API_ENDPOINTS.MARKETING_UTM_BREAKDOWN, params);

export const getRevenueAttribution = (api, params) =>
  get(api, API_ENDPOINTS.MARKETING_REVENUE_ATTRIBUTION, params);

export const getUnattributedRevenue = (api, params) =>
  get(api, API_ENDPOINTS.MARKETING_UNATTRIBUTED_REVENUE, params);

export const getLeadTrends = (api, params) =>
  get(api, API_ENDPOINTS.MARKETING_LEAD_TRENDS, params);

export const getAttributionBreakdown = (api, params) =>
  get(api, API_ENDPOINTS.MARKETING_ATTRIBUTION_BREAKDOWN, params);

export const getAttributionDrilldown = (api, params) =>
  get(api, API_ENDPOINTS.MARKETING_ATTRIBUTION_DRILLDOWN, params);
